export var AfriexOS;
(function (AfriexOS) {
    AfriexOS["MacOs"] = "MACOS";
    AfriexOS["Windows"] = "WINDOWS";
    AfriexOS["Linux"] = "LINUX";
    AfriexOS["IOS"] = "IOS";
    AfriexOS["Android"] = "ANDROID";
})(AfriexOS || (AfriexOS = {}));
//# sourceMappingURL=AfriexOS.js.map